import axios from "axios";

import { getHeaderWithToken } from "../headers";

// ===================================================================================
//  GET NEWS
// ===================================================================================
export const newsIsLoading = () => {
	return {
		type: "NEWS_ARE_LOADING"
	};
};

export const newsHasError = err => {
	return {
		type: "NEWS_HAS_ERROR",
		hasErrored: true,
		error: err
	};
};

export const newsSuccess = data => {
	return {
		type: "NEWS_SUCCESS",
		data
	};
};

export function getNews(id = null, token = null) {
	return dispatch => {
		dispatch(newsIsLoading());

		// Add id of record to find if passed
		const endPoint = "news" + (id ? `/${id}` : "");

		const params = {
			language: process.env.REACT_APP_LANGUAGE
		};

		// return console.log("the api url ", process.env.REACT_APP_API_URL)
		axios.get(process.env.REACT_APP_API_URL + endPoint, {
			headers: getHeaderWithToken(token),
			params
		})
			.then(response => {
				if (response.data.status && response.data.status !== 200) {
					dispatch(newsHasError(response.data.errors));
				} else {
					return dispatch(newsSuccess(response));
				}
			})
			.catch(err => {
				dispatch(newsHasError(err.response.data.message));
			});
	};
}

// ===================================================================================
//  CLEAR
// ===================================================================================
export const clearNews = () => {
	return {
		type: "NEWS_CLEAR"
	};
};



// WEBPACK FOOTER //
// ./src/store/actions/news.js